import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedIconData)?_c(VTooltip,{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c(VIcon,_vm._g(_vm._b({attrs:{"icon":"","color":_vm.selectedIconData.color}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.selectedIconData.icon)+" ")])]}}],null,false,3038380329)},[_c('span',[_vm._v(_vm._s(_vm.selectedIconData.toolTip))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }